import React, { useState } from "react";

import "../../../../index.css";
import ImgProfile from "../../../../assets//images/logo-default.png";
import { toast } from "react-toastify";

const ImgUpload = ({ onChange, src, required }) => (
  <label htmlFor="photo-upload" className="custom-file-upload fas">
    <div className="img-wrap img-upload">
      <img
        htmlFor="photo-upload"
        className="img-profile-pic"
        src={src}
        alt="Profile Preview"
      />
    </div>
    <input
      id="photo-upload"
      type="file"
      onChange={onChange}
      style={{ display: "none" }}
      required={required}
      size={10000}
      accept=".jpg, .jpeg, .png, .webp"
    />
  </label>
);

const Profile = ({ onSubmit, src, name, status }) => (
  <div className="">
    <form onSubmit={onSubmit}>
      <h1>Profile Card</h1>
      <label className="custom-file-upload fas">
        <div className="img-wrap">
          <img htmlFor="photo-upload" src={src} alt="Profile Preview" />
        </div>
      </label>
      <div className="name">{name}</div>
      <div className="status">{status}</div>
      <button type="submit" className="edit">
        Edit Profile
      </button>
    </form>
  </div>
);

const Edit = ({ onSubmit, children, auxLabel }) => (
  <div className="card card-logo border-0 mt-2 d-flex justify-content-center align-items-center">
    <form onSubmit={onSubmit} style={{ height: "168px" }}>
      {children}
    </form>
    <span className="profile-pic">Escolher Logo {auxLabel}</span>
  </div>
);

const Logo = ({ required, onFileChange }) => {
  const [file, setFile] = useState("");
  const [name, setName] = useState("");
  const [status, setStatus] = useState("");
  const [active, setActive] = useState("edit");
  const [imagePreviewUrl, setImagePreviewUrl] = useState(ImgProfile);

  const readFileAsBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onload = () => {
        setImagePreviewUrl(reader.result);
        resolve(reader.result);
      };

      reader.onerror = (error) => {
        reject(error);
      };

      reader.readAsDataURL(file);
    });
  };

  const photoUpload = async (e) => {
    e.preventDefault();
    const file = e.target.files[0];
  
    // Tipos de arquivos permitidos
    const allowedTypes = ['image/webp', 'image/jpeg', 'image/png', 'image/svg+xml'];
  
    // Verifica se o tipo do arquivo é permitido
    if (!allowedTypes.includes(file.type)) {
      toast.error("Tipo de arquivo não permitido. Apenas webp, jpg, jpeg, png e svg são aceitos.");
      return;
    }

     // Verifica se o tamanho do arquivo é maior que 10MB
     const maxSize = 10 * 1024 * 1024; // 10MB em bytes
     if (file.size > maxSize) {
       toast.error("O arquivo excede o tamanho máximo permitido de 10MB.");
       return;
     }
  
    try {
      const base64String = await readFileAsBase64(file);
      setFile(file);
      // setImagePreviewUrl(base64String);
      onFileChange(base64String);
    } catch (error) {
      console.error("Error reading file:", error);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    let activeP = active === "edit" ? "profile" : "edit";
    setActive(activeP);

    // Chama a função de callback e passa o arquivo selecionado
    if (file) {
      setFile(file);
    }
  };

  return (
    <div>
      {active === "edit" ? (
        <Edit onSubmit={handleSubmit} auxLabel={required === true ? "*" : ""}>
          <ImgUpload
            onChange={photoUpload}
            src={imagePreviewUrl}
            required={required}
          />
        </Edit>
      ) : (
        <Profile
          onSubmit={handleSubmit}
          src={imagePreviewUrl}
          name={name}
          status={status}
        />
      )}
    </div>
  );
};

export default Logo;
